import { Container, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import Page from "../../../components/layouts/Page";
import bg from "../../../assets/fons/background_fost.jpg";
import img from "../../../assets/headers/protagonistes.jpeg";
import Header from "../../../components/layouts/Header";
import { useTranslation } from "react-i18next";
import { CheckCircle } from "@mui/icons-material";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router";

const Ok = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Page title={"Merolla de Berguedà - " + t("reserva_ok")}>
            <Header title={t("reserva_ok")} img={img} />
            <Box className={classes.main}>
                <Container>
                    <Box textAlign={"center"}>
                        <CheckCircle style={{ fill: "green", width: 120, height: 120 }} />
                        <Typography variant="h5" my={3}>
                            {t("reserva_feta")}
                        </Typography>{" "}
                        <Typography variant="body1" my={3}>
                            {t("email_enviat")}
                        </Typography>
                        <CustomButton title={t("tornar")} onClick={() => navigate("/")} />
                    </Box>
                </Container>
            </Box>
        </Page>
    );
};

export default Ok;

const useStyles = makeStyles((theme) => ({
    main: {
        background: `url(${bg})`,
        display: "flex",
        paddingTop: 100,
        paddingBottom: 200,
        flexDirection: "column",
    },
}));
